//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { version } from '../../package.json';

export default {
  name: 'ViuBox',
  props: {
    /**
     * Tema que aplicará
     * @values light, dark.
     */
    theme: {
      type: String,
      default: 'light'
    },
    /**
     * Contenido del título. Irá a la izquierda.
     */
    title: {
      type: String
    },
    /**
     * Contenido del subtítulo. Irá a la derecha.
     */
    subtitle: {
      type: String
    }
  },
  data: () => ({
    version
  }),
  computed: {
    hasHeader() {
      if (
        (this.title !== undefined && this.title.length > 0) ||
        (this.subtitle !== undefined && this.subtitle.length > 0) ||
        (this.$slots.header && this.$slots.header.length > 0)
      ) {
        return true;
      }
      return false;
    },
    hasFooter() {
      if (this.$slots.footer && this.$slots.footer.length > 0) {
        return true;
      }
      return false;
    }
  }
};
